import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { GameSection } from '../../models/game-section.model';

@Component({
  selector: 'app-game-hero',
  templateUrl: './game-hero.component.html',
  styleUrl: './game-hero.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class GameHeroComponent {
  game = input.required<GameSection>();
}
